export default {
  dialogContent: {
    overflow: 'visible',
    width: '500px',
    backgroundColor: '#f9f9f9'
  },
  label: {
    marginBottom: '15px',
    fontSize: '16px'
  },
  dataRow: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  splitInfo: {
    marginTop: 20,
    padding: '15px',
    backgroundColor: '#ffffff',
    borderRadius: 4,
    border: '1px solid #e0e0e0'
  },
  splitInfoLabel: {
    fontWeight: 600,
    fontSize: 14,
    marginBottom: 8,
    color: '#333'
  },
  splitInfoText: {
    fontSize: 14,
    color: '#666'
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '10px 0',
    '& button': {
      marginRight: '10px'
    }
  }
};
